
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BondsServices } from 'src/app/services/bonds.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { SelectEventBondComponent } from '../events/select-event-bond/select-event-bond.component';
import { CreateBondComponent } from '../events/create-bond/create-bond.component';
import { InfoBondComponent } from '../events/info-bond/info-bond.component';
import { ApiBusinessService } from 'src/app/services/api-business.service';

@Component({
  selector: 'app-bonds',
  templateUrl: './bonds.component.html',
  styleUrls: ['./bonds.component.scss']
})
export class BondsComponent implements OnInit {

  business: any;
  place!: any;
  eventos: any[] = [];
  profile!: any;
  searchText!: string;
  now: Date = new Date();
  @Input() idVenue!: any;

  displayedColumns: string[] = ['actions', 'name', 'discount', 'status'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  @ViewChild(MatSort) sort: MatSort = new MatSort;
  sorted!: any;

  page = 1;

  @Output() changeTag: EventEmitter<any> = new EventEmitter<any>();
  loaded: boolean = false;
  loadingPage: boolean = true;

  finishScroll: boolean = false;
  @ViewChild('containerScroll', { static: false }) containerScroll: ElementRef;
  private searchTerms = new Subject<string>();
  private loadGeneration = 0;
  allowCreate!: any;

  constructor(private dialog: MatDialog, private router: Router, private auth: AuthenticationService,
    private bondService: BondsServices, private apiBusiness: ApiBusinessService) { }

  ngOnInit(): void {
    this.profile = this.auth.getProfile();
    this.now.setHours(0);
    this.now.setMinutes(0);
    let rolesProfile = this.auth.getProfile()?.roles.map((role: any) => role.name);
    this.allowCreate = rolesProfile?.find((element) => (element == 'admin' || element == 'superadmin' ||element == 'ACCESS_CLOUD' || element == 'ACCOUNT_OWNER' || element == 'ACCESS_EXTERN_EVENTS' || element == 'ACCESS_ADMIN' || element == 'ACCESS_MANAGER' || element == 'CREATE_EVENTS'));
  }

  ngAfterViewInit() {
    this.apiBusiness.changed.subscribe({
      next: (value) => {
        this.place = localStorage.getItem('places');
        this.business = JSON.parse(localStorage.getItem('business') || '{}');
        if (value) {
          this.updateBonds();
        }
      }
    })
    this.searchTerms.pipe(
      debounceTime(500), // Espera 300ms después de cada pulsación de tecla
      distinctUntilChanged(), // Ignora si el nuevo término de búsqueda es igual al anterior
    ).subscribe(items => {
      this.searchText = items;
      this.updateBonds();
    });
  }

  getData() {
    const generation = this.loadGeneration;
    let places = [];
    if (this.place) {
      places = [this.place];
    }
    this.bondService.getBonds(this.business?.id, this.page, this.searchText, this.sorted, places).subscribe({
      next: (res) => {
        if (generation !== this.loadGeneration) return;
        const items = (res.discounts || res.data || []).filter((d: any) => d.rule_type === 'pass');
        this.eventos = this.eventos.concat(items);
        this.finishScroll = true;
        this.dataSource = new MatTableDataSource(this.eventos);
        this.dataSource.sort = this.sort;

        this.loaded = true;
        this.loadingPage = false;
      }
    })
  }

  updateBonds() {
    this.loadGeneration++;
    this.page = 1;
    this.loadingPage = true;
    this.finishScroll = false;
    this.eventos = [];
    this.getData();
  }

  searchEvents(event) {
    this.searchTerms.next(event);
  }

  openBond(bond: any) {
    const dialogRef = this.dialog.open(InfoBondComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      width: '750px',
      data: {
        idCompany: this.business.id,
        object: bond
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.bond) {
        this.openSelectEvents(res);
      }
    });
  }

  getStatus(bond: any) {
    let items: any[] = bond.pass_items || [];
    let events = items.map(i => i.event).filter(e => !!e);
    let exitDraft = events.find(value => value.draft);
    if (exitDraft) {
      return { color: '#7A7A7A', status: 'Con evento en borrador' };
    }

    if (bond.ends_at && new Date(bond.ends_at) < this.now) {
      return { color: '#B75470', status: 'Abono terminado' };
    }

    if (bond.active && bond.starts_at && new Date(bond.starts_at) > this.now) {
      return { color: '#2F86EB', status: 'Próximamente' };
    }

    if (bond.active) {
      return { color: '#21CB7C', status: 'Abono activo' };
    }

    return { color: '#FFA800', status: 'Abono inactivo' };
  }

  openCreateEvent() {
    this.router.navigate(['/panel-control/events/new-event/info-event']);
  }

  // Sort
  sortData(sort: Sort) {
    if (this.eventos.length > 1) {
      const isAsc = (sort.direction === 'asc') ? 'asc' : 'desc';
      if (sort.direction) {
        this.sorted = { sortedBy: sort.active, sort: isAsc };
      } else {
        this.sorted = null;
      }
      this.updateBonds();
    }
  }

  openCreateBond(object?: any, edit?: boolean, back?: boolean) {
    let bondRes = object;
    if (edit && !back) {
      bondRes = {
        id: object.id,
        name: object.name,
        type: object.discount_mode,
        cuantity: object.discount_value,
        events: (object.pass_items || []).map(i => i.event).filter(e => !!e)
      }
    }
    const dialogRef = this.dialog.open(CreateBondComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      disableClose: true,
      width: '750px',
      data: {
        idCompany: this.business.id,
        object: bondRes,
        edit: edit
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res?.bond) {
        if (!bondRes) {
          bondRes = { id: null, name: '', type: '', cuantity: 0, events: [], start_date: '', end_date: '' };
        }
        bondRes.name = res.bond.name;
        bondRes.type = res.bond.type;
        bondRes.cuantity = res.bond.cuantity;
        bondRes.start_date = res.bond.start_date;
        bondRes.end_date = res.bond.end_date;
        res.bond.events = bondRes?.events;
        this.openSelectEvents(res.bond, bondRes, edit);
      }
    });
  }

  openSelectEvents(object: any, bond?: any, edit?: boolean) {
    const dialogRef = this.dialog.open(SelectEventBondComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      width: '750px',
      disableClose: true,
      data: {
        idCompany: this.business.id,
        edit: edit,
        object: bond
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (res.back) {
          let objectBack = edit ? bond : object;
          this.openCreateBond(objectBack, edit, true);
        } else if (res.events) {
          let objectBack = edit ? bond : object;
          this.sendCreateBond(objectBack, res.events, edit);
        }
      }
    });
  }

  sendCreateBond(object: any, events: any[], edit) {
    const pass_items = events.map(e => ({ event_id: e.id || e, session_ids: [] }));
    let payload = {
      name: object.name,
      rule_type: 'pass',
      discount_mode: object.type,
      discount_value: object.cuantity,
      pass_items,
      start_date: object.start_date,
      end_date: object.end_date,
      active: true,
      apply_scope: 'company'
    };
    if (edit) {
      this.bondService.editBond(object.id, payload).subscribe({
        next: (res) => {
          this.openInfoCard('Abono editado correctamente.');
          this.updateBonds();
        },
        error: (err) => {
          this.openInfoCard('¡Vaya! Ha ocurrido un error al editar el abono, vuelve a intentarlo más tarde.');
        }
      });
    } else {
      this.bondService.createBond(payload).subscribe({
        next: (res) => {
          this.openInfoCard('Abono creado correctamente.');
          this.updateBonds();
        },
        error: (err) => {
          this.openInfoCard('¡Vaya! Ha ocurrido un error al crear el abono, vuelve a intentarlo más tarde.');
        }
      });
    }
  }

  openInfoCard(msg: string, disabledClose: boolean = false) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        text: msg
      }
    });
  }

  //Pagination
  @HostListener('window:scroll', ['$event'])
  @HostListener('scroll', ['$event'])
  public isScrolledInfinityView(event) {
    if (!this.loadingPage) {
      if (!this.finishScroll) {
        const element = this.containerScroll.nativeElement.getBoundingClientRect();
        let bottomShown = element.bottom <= window.innerHeight;
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
          bottomShown = true;
        }
        if (bottomShown && !this.finishScroll) {
          this.page++;
          this.loadingPage = true;
          setTimeout(() => {
            this.getData();
          }, 200);
        }
        // }
      } else {
        this.finishScroll = true;
      }
    }
  }

  deleteBond(bond: any) {
    if (bond.purchases > 0) {
      return;
    }
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: '¿Estás seguro de que quieres eliminar el abono? Esta acción no podrá deshacerse.',
        btnCancel: true,
        warning: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bondService.deleteBond(bond.id).subscribe({
          next: (res) => {
            this.openInfoCard('Abono eliminado correctamente');
            this.updateBonds();
          },
          error: (err) => {
            this.openInfoCard('¡Vaya! Ha ocurrido un error al eliminar el abono: ' + (err.error?.message || err.error?.msg || 'inténtalo de nuevo.'));
          }
        });
      }
    });
  }

  toggleBondStatus(bond: any) {
    const action = bond.active ? 'desactivar' : 'activar';
    const newActiveState = !bond.active;
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: `¿Estás seguro de que quieres ${action} el abono "${bond.name}"?`,
        btnCancel: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bondService.toggleActiveStatus(bond.id, newActiveState).subscribe({
          next: (res) => {
            const message = bond.active ? 'Abono desactivado correctamente' : 'Abono activado correctamente';
            this.openInfoCard(message);
            this.updateBonds();
          },
          error: (err) => {
            this.openInfoCard('¡Vaya! Ha ocurrido un error al cambiar el estado del abono.');
          }
        });
      }
    });
  }

}

